// extracted by mini-css-extract-plugin
export default {"small":"IconInfoFilled_small__79uwQ"};